import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
export default {
    numSweepRules: {
        datapoint: {
            name: 'TnS_NumSweepRules',
            customData: function (sweepRuleCollectionLength) { return [sweepRuleCollectionLength]; },
        },
    },
    setSweepRule: {
        datapoint: {
            name: 'TnS_SetSweepRule',
            customData: function (sweepRuleId, sweepOperation) { return [
                sweepRuleId,
                sweepOperation,
            ]; },
        },
    },
    sweepRuleInfo: {
        datapoint: {
            name: 'TnS_SweepRuleInformation',
            customData: function (sweepRule) { return [
                folderIdToName(sweepRule.SweepConditions[0].SourceFolderId),
                folderIdToName(sweepRule.SweepActions[0].DestinationFolderId),
                sweepRule.SweepActions[0].CleanUpType,
                sweepRule.SweepActions[0].KeepCount,
            ]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map